import { render, staticRenderFns } from "./CommonUserName.vue?vue&type=template&id=5721c660"
import script from "./CommonUserName.vue?vue&type=script&lang=js"
export * from "./CommonUserName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports